export const CALENDAR_POPOUT_OPTIONS = {
    width: 1095,
    height: 640,
};
